import { i18n } from '@/i18n'
import moment from 'moment'

function getDateFormat (value, locale = null, format = 'DD-MM-YYYY HH:mm') {
  if (!locale) {
    locale = i18n.locale
  }

  return value ? moment(value).locale(locale).format(format) : ''
}

export { getDateFormat }
